<template>
  <div class="details">
    <div class="details-nav">
      <div class="nav-box">
        <div class="nav-box-img">
          <el-image :lazy="true" :src="require('../../assets/image/details/position.png')" fit="fill"></el-image>
        </div>
        <div>当前位置：</div>
        <div class="details-bread">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{  path: '/resource/all',query:{ref:'ref99999'} }">资源</el-breadcrumb-item>
            <el-breadcrumb-item>{{bookDetails.bookName}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>

      </div>
    </div>
    <div class="details-show">
      <div class="details-show-title">
        <div>
          {{bookDetails.bookName}}
        </div>
        <div class="details-show-author">
          作者: {{ bookDetails.author || '暂无' }}
        </div>
      </div>

      <videosVue :cover_url="cover_url" :src="src" class="vodeps" ref="hlsplayRef"></videosVue>
      <div class="bref">
        简介：{{ bookDetails.brief || '暂无' }}
      </div>
    </div>
  </div>
</template>

<script>
  import {getBookById} from '../../api/resource'
  import videosVue from '../../components/common/videos.vue';

  export default {
    name: 'PortalDetailShows',

    data() {
      return {
        bookDetails: {
          bookName: '',
          // 地区
          address: '',
          // 收藏地
          collectionplace: '',
          // 类别
          category: '',
          // 民族
          nation: '',
          // 页数
          pages: '',
          // 简介
          brief: '',
          videoUrl: '',
          author:''
        },
        datalist: [],
        src: '',
        cover_url: ''
        // cover_url:require('../../assets/image/index/imagesbg.png')
      };
    },

    mounted() {
      this.init()
    },

    methods: {
      getDetail() {
        return new Promise((provide, reject) => {
          let params = {
            bookId: this.$route.query.bookId
          }
          getBookById(params).then(res => {
            if (res.data.code == 200 && res.data.data) {
              this.datalist = JSON.parse(JSON.stringify(res.data.data))
              // 提取元数据模版值
              let con = [
                {
                  title: '题名',
                  field: 'bookName'
                },
                {
                  title: '馆藏地址',
                  field: 'address'
                },
                {
                  title: '地区',
                  field: 'collectionplace'
                },
                {
                  title: '分类',
                  field: 'category'
                },
                {
                  title: '民族',
                  field: 'nation'
                },
                {
                  title: '页数',
                  field: 'pages'
                },
                {
                  title:'主要责任人',
                  field:'author'
                },
                {
                  title: '简介',
                  field: 'brief'
                },
                {
                  title: '视频路径',
                  field: 'videoUrl'
                },
              ]
              con.forEach(e => {
                const ds = this.datalist.find(i => {
                  return i.captions == e.title
                })
                if (ds) {
                  this.bookDetails[e.field] = ds.attributeValue
                }
              });
              if (this.bookDetails["videoUrl"] != '') {
                provide(this.bookDetails["videoUrl"])
              }
            }
          })
        })
      },
      setUrl() {
        // this.$refs.hlsplayRef.setSrc('播放地址')
      },
      async init() {
        let srcd = await this.getDetail()
        if (srcd.attributeValue != '/') {
          this.src = srcd.replace('/home/uftp/books/', '/fileBookWeb/')
          this.$refs.hlsplayRef.setSrc(this.src)
        }
      }
    },
    components: {
      videosVue
    }
  };
</script>

<style lang="less" scoped>
  .details {
    background: url('../../assets/image/resource/res_main.png');
    padding-top: 1.042rem;
    padding-bottom: 2.083rem;

    .details-nav {
      width: 62.5rem;
      height: 2.604rem;
      margin: 0 auto;
      background-color: #fff;

      .nav-box {
        display: flex;
        height: 100%;
        align-items: center;
        padding-left: 1.042rem;
        font-size: 0.833rem;
        color: #333333;

        .nav-box-img {
          margin-right: 0.625rem;

          .el-image {
            width: 0.677rem;
            height: 0.833rem;
          }
        }

        .details-bread {
          /deep/ .el-breadcrumb {
            .el-breadcrumb__item {
              .el-breadcrumb__inner.is-link {
                font-size: 0.833rem;
                color: #333333;
                font-weight: unset;
              }

              .el-breadcrumb__inner {
                color: #b1222b;
              }
            }
          }

        }
      }
    }

    .details-show {
      width: 62.5rem;
      margin: 0 auto;
      background-color: #fff;
      margin-top: 0.625rem;
      padding: 0 1.563rem;
      padding-bottom: 1.563rem;

      .details-show-title {
        font-size: 1.25rem;
        font-weight: bold;
        color: #333333;
        text-align: center;
        padding-top: 2.5rem;
        padding-bottom: 0.533rem;
        border-bottom: 1px solid #ddd;
        margin-bottom: 1.563rem;
        .details-show-author{
          margin-top: 5px;
          font-size: 0.8rem;
          font-weight: normal;
        }
      }
      .bref{
        margin-top: 15px;
        font-size: 0.8rem;
      }
      .vodeps {
        width: 59.375rem;
        height: 33.229rem;
      }
    }
  }
</style>
